Views.add(new class extends AbstractView {

  constructor() {
    super({
      name: 'homepage',
      branch: null,
      depth: 0
    })
    this.blocksPostLoadIds = []
  }

  onActive() {
    this.scrollToTop()
    Utils.restartAnimations(this.element)
  }

  mainTitle() {
    return Wording.window_title
  }

  smallTitle() {
    return Wording.homepage_subtitle
  }

  sharedEventListeners() {
    const initIframe = iframe => {
      let fixedHeight = false
      iframe.contentDocument.body.innerHTML = iframe.textContent
      iframe.innerText = ''
      iframe.contentDocument.body.style['margin'] = '0px'
      iframe.contentDocument.body.style['padding'] = '0px'

      if (iframe.contentDocument.body.querySelectorAll('stream')[0]) {
        fixedHeight = iframe.contentDocument.body.querySelectorAll('stream')[0].getAttribute('height')
      }

      if (iframe.contentDocument.body.querySelectorAll('img')[0]) {
        fixedHeight = iframe.contentDocument.body.querySelectorAll('img')[0].getAttribute('height')
      }

      if (iframe.contentDocument.body.querySelectorAll('iframe')[0]) {
        fixedHeight = iframe.contentDocument.body.querySelectorAll('iframe')[0].getAttribute('height')
      }

      if (fixedHeight) {
        if (fixedHeight.match('px') == null) {
          fixedHeight += 'px'
        }
        iframe.style['height'] = fixedHeight
      }

      let scripts = iframe.contentDocument.body.querySelectorAll('script')

      for (var i = 0; i < scripts.length; i++) {
        let videoScript = document.createElement('script')
        videoScript.setAttribute('src', scripts[i].src)
        iframe.contentDocument.head.appendChild(videoScript)
      }
    };

    Utils.forEach(Dom.findAll('widget', '.load-in-iframe'), function(iframe) {
      if (iframe.contentDocument.readyState != 'complete') iframe.addEventListener('load', initIframe.bind(this, iframe))
      else initIframe(iframe)
    })
  }

  useOldCards() {
    this.app._new_homescreen = false
    this.sharedEventListeners()

    Dom.findById('widget', 'slaask-widget-homepage-conv-button').addEventListener("click", () => {
      Conversations.clickOnCta()
    })

    Dom.findById('widget', 'slaask-widget-homepage-conv-button2').addEventListener("click", () => {
      Views.jumpToViewByName('conversations')
    })

    if (Meetings.enabled) {
      Dom.findById('widget', 'slaask-widget-homepage-meetings').addEventListener("click", () => {
        Dom.addClass('widget', 'slaask-slide-from-right')
        Dom.addClass('widget', 'slaask-widget-open-meetings')
        const meetingParams = {
          token: this.app._guest_token,
          key: this.app._api_key
        }
        const meetingParamsStr = Object.keys(meetingParams)
          .map(key => (key + "=" + meetingParams[key]))
          .join('&')
        const meetingUrl = this.app._meetings_base_url + "?" + meetingParamsStr
        Views.jumpToViewByName('iframe', meetingUrl)
      })
    }

    if(this.app._status_enabled) {
      Dom.findById('widget', 'slaask-widget-homepage-status').addEventListener("click", (e) => {
        e.preventDefault()
        Views.jumpToViewByName('iframe', this.app._status_page_url)
      })
    }

    if (this.app._reply_mode != 'personalized' || !this.app._diplay_members) {
      let usersRemoved = false;
  
      Conversations.on('adding-summary', (conversation, containerEl) => {
        void conversation
  
        if (!usersRemoved && containerEl.id == "slaask-widget-homepage-conversations-users") {
          let users = Dom.findAll('widget', '#slaask-widget-homepage-conversations-users .slaask-widget-homepage-conversations-users-image')
          for (let i = 0 ; i < users.length ; i++) {
            Utils.removeElement(users[i])
          }
          Dom.findById('widget', 'slaask-widget-homepage-conversations-users-title').innerHTML = Wording.homepage_conversation_yours
          Dom.addClass('widget', '#slaask-widget-homepage-conversations-users', 'slaask-widget-homepage-conversations-current')
          usersRemoved = true
        }
      })
    }


    Homepage._initFaqForm()
    Homepage._initSubscribeForm()
  }

  useNewCards() {
    this.app._new_homescreen = true
    this.sharedEventListeners()

    // Custom Cards v2
    this.blocksPostLoadIds.forEach((block) => {
      let data = {
        settings: block.settings,
        domElement: Dom.findById('widget', block.id)
      };

      HtmlSettings.loadPostBuildSettings(block.type, data)
    });

    // Add accessibility attributes to cards
    this.addAccessibilityToCards()
  }

  addAccessibilityToCards() {
    // Add tabindex and aria-label to all homepage cards
    const cards = Dom.findAll('widget', '.slaask-widget-homepage-card')
    
    cards.forEach((card) => {
      // Add tabindex to make cards focusable
      card.setAttribute('tabindex', '0')
    })
    
    // Add role=button to conversation CTAs
    const conversationButtons = Dom.findAll('widget', '.switch-view-block-conversation, .switch-view-block-conversations')
    conversationButtons.forEach((button) => {
      button.setAttribute('role', 'button')
      button.setAttribute('tabindex', '0')
    })
    
    // Add role=button to meetings card
    const meetingsCard = Dom.findById('widget', 'slaask-widget-homepage-meetings')
    if (meetingsCard) {
      meetingsCard.setAttribute('role', 'button')
      meetingsCard.setAttribute('tabindex', '0')
    }
    
    // Add role=button to phone button
    const phoneButton = Dom.findById('widget', 'phone-button-1')
    if (phoneButton) {
      phoneButton.setAttribute('role', 'button')
      phoneButton.setAttribute('tabindex', '0')
    }
    
    // Add role=heading to card titles
    const cardTitles = Dom.findAll('widget', '.slaask-widget-homepage-card-title')
    cardTitles.forEach((title) => {
      title.setAttribute('role', 'heading')
      title.setAttribute('aria-level', '2')
    })
  }

  initEventListeners() {
    if (this.app._custom_cards.length > 0) {
      this.useNewCards()
    } else {
      this.useOldCards()
    }
  }

  _oldHtmlBase() {
    let conversationsCardHtml   = '',
        helpCenterCardHtml      = '',
        meetingsCardHtml        = '',
        newsletterCardHtml      = '',
        phoneCardHtml           = '',
        statusCardHtml          = '',
        productHuntCardHtml     = '',
        attentionGrabberHtml    = '',
        customsCardHtml         = '';

    // Convs card
    let conversationsUsersHtml = '<div></div>'

    let shuffledUsers = []
    if (this.app._reply_mode == 'personalized' && this.app._diplay_members) {
      conversationsUsersHtml = '<div id="slaask-widget-homepage-conversations-users" class="slaask-widget-homepage-conversations-users">'
      shuffledUsers = Utils.shuffleArray(this.app._widget_users)

      for (let i = 0; i < shuffledUsers.length; i++) {
        if (i < 6) {
          conversationsUsersHtml += '<img class="slaask-widget-homepage-conversations-users-image" src="' + shuffledUsers[i].image + '" onerror="onerror=null;src=\'' + this.app._support_img + '\';">'
        }
      }

      conversationsUsersHtml += '</div>'
    }
    let ctaConversationsListHidden = Views.getByName('conversations').soapy ? 'slaask-hidden': ''

    conversationsCardHtml = `
      <div id="slaask-widget-homepage-conversations" class="slaask-widget-homepage-card slaask-widget-card">
        <span class="slaask-widget-homepage-card-title" id="slaask-widget-homepage-conversations-users-title">
          ${Wording.homepage_conversation_start}
        </span>
        ${conversationsUsersHtml}
        <div class="slaask-widget-homepage-cta-row">
          <div class="slaask-widget-homepage-ctas">
            <button class="slaask-widget-homepage-cta" id="slaask-widget-homepage-conv-button" style="background-color: ${this.app._window_color};color: ${this.app._title_color}">
              ${Wording.new_conversation_text}
            </button>
          </div>
          <span class="slaask-widget-homepage-cta2 ${ctaConversationsListHidden}" id="slaask-widget-homepage-conv-button2" style="color: ${this.app._window_color}" tabindex="0" role="button" aria-label="${Wording.homepage_conversation_previous}">
            ${Wording.homepage_conversation_previous}
          </span>
        </div>
      </div>`

    // Helpcenter card
    if (this.app._hc_enabled) {
      helpCenterCardHtml = `
        <div id="slaask-widget-homepage-helpcenter" class="slaask-widget-homepage-card slaask-widget-card">
          <span class="slaask-widget-homepage-card-title">
            ${Wording.homepage_helpcenter_title}
          </span>
          <form class="slaask-widget-homepage-helpcenter-form slaask-widget-homepage-form" id="slaask-widget-homepage-helpcenter-form">
            <input id="slaask-widget-homepage-helpcenter-input" autocomplete="off" class="slaask-input slaask-input-survey slaask-widget-homepage-input" placeholder="${Wording.homepage_helpcenter_placeholder}" type="text" value="" required="required"/>
            <label class="slaask-widget-homepage-submit-label" style="background: ${this.app._window_color};">
              <input type="submit" class="slaask-widget-homepage-submit" id="slaask-rating-sutmit" value=""/>
              <div class="slaask-widget-homepage-submit-image" id="slaask-widget-homepage-submit-image">
                ${Svg.hcSearch()}
              </div>
              <div class="slaask-homepage-loader-wrapper slaask-hidden" id="slaask-homepage-helpcenter-loader">
                <div class="slaask-homepage-loader slaask-homepage-loader-small slaask-homepage-loader-white"></div>
              </div>
            </label>
          </form>
          <div id="slaask-widget-homepage-helpcenter-content" class="slaask-widget-homepage-helpcenter-content"></div>
        </div>`
    }

    // Meeting card
    if (Meetings.enabled) {
      meetingsCardHtml = `
        <a id="slaask-widget-homepage-meetings" class="slaask-widget-homepage-card slaask-widget-homepage-card-link slaask-widget-card slaask-widget-card-horizontal" role="button" aria-label="${Wording.homepage_meetings_title} - ${Wording.homepage_meetings_desc}" tabindex="0">
          <div class="slaask-widget-homepage-card-image">
            ${Svg.meetings(this.app._window_color)}
          </div>
          <div class="slaask-widget-homepage-card-content">
            <span class="slaask-widget-homepage-card-title">
              ${Wording.homepage_meetings_title}
            </span>
            <p>
              ${Wording.homepage_meetings_desc}
            </p>
          </div>
        </a>`
    }

    // Newsletter card
    if (this.app._newsletter_enabled) {
      newsletterCardHtml = `
        <div id="slaask-widget-homepage-newsletter" class="slaask-widget-homepage-card slaask-widget-card" role="form" aria-label="${Wording.homepage_newsletter_title}">
          <span class="slaask-widget-homepage-card-title">
            ${Wording.homepage_newsletter_title}
          </span>
          <form class="slaask-widget-homepage-newsletter-form slaask-widget-homepage-form" id="slaask-widget-homepage-newsletter-form">
            <input id="slaask-widget-homepage-newsletter-input" autocomplete="off" class="slaask-input slaask-input-survey slaask-widget-homepage-input" placeholder="${Wording.email_placeholder_content}" type="text" value="" required="required" aria-label="${Wording.email_placeholder_content}" tabindex="0"/>
            <label class="slaask-widget-homepage-submit-label" style="background: ${this.app._window_color};">
              <input type="submit" class="slaask-widget-homepage-submit" id="slaask-rating-sutmit" value="" aria-label="${Wording.homepage_newsletter_title}" tabindex="0"/>
              <img class="slaask-widget-homepage-submit-image" id="slaask-widget-homepage-submit-newsletter-image" src="${this.app._cdn_url}/check-icon.svg" alt="Envoyer">
              <div class="slaask-homepage-loader-wrapper slaask-hidden" id="slaask-homepage-newsletter-loader">
                <div class="slaask-homepage-loader slaask-homepage-loader-small slaask-homepage-loader-white"></div>
              </div>
            </label>
          </form>
          <div id="slaask-widget-homepage-newsletter-content" class="slaask-widget-homepage-newsletter-content"></div>
        </div>`
    }

    // Phone card
    if (this.app._phone_enabled) {
      phoneCardHtml = `
        <div id="slaask-widget-homepage-phone" class="slaask-widget-homepage-card slaask-widget-card slaask-widget-card-horizontal">
          <div class="slaask-widget-homepage-card-image">
            ${Svg.phone(this.app._window_color)}
          </div>
          <div class="slaask-widget-homepage-card-content">
            <span class="slaask-widget-homepage-card-title">
              ${Wording.homepage_phone_title}
            </span>
            <p>
              ${Wording.homepage_phone_desc}
            </p>
            <a href="tel:${this.app._phone_number}" class="slaask-widget-homepage-cta" id="slaask-widget-homepage-phone-button" style="background-color: ${this.app._window_color};color: ${this.app._title_color}">
              ${this.app._phone_number}
              <img style="float: left;margin-top: 10px;width: 18px;margin-right: 2px;" src="${this.app._cdn_url}/phone-icon.svg">
            </a>
          </div>
        </div>`
    }

    // Status card
    if (this.app._status_enabled) {
      let statusArray       = this.app._status.split('//')

      statusCardHtml = `
        <a href="${this.app._status_page_url}" id="slaask-widget-homepage-status" class="slaask-widget-homepage-card slaask-widget-homepage-card-link slaask-widget-card">
          <div class="slaask-widget-homepage-card-content">
            <span class="slaask-widget-homepage-card-title" style="display: flex">
              ${Svg.status(this.app._window_color, statusArray[0])}${Wording.homepage_status_title}${statusArray[1]}
            </span>
            ${statusArray[2] ? '<p>' + statusArray[2] + '</p>' : ''}
            ${statusArray[3] ? '<p>' + statusArray[3] + '</p>' : ''}
            <p>
              ${Wording.homepage_status_desc}${this.app._status_updated}
            </p>
          </div>
        </a>`
    }

    // Product Hunt card
    if (this.app._ph_info) {
      productHuntCardHtml = `
        <div id="slaask-widget-homepage-producthunt" class="slaask-widget-homepage-card slaask-widget-card slaask-widget-homepage-custom-card">
          <div class="slaask-widget-homepage-card-list">
            <div class="slaask-widget-homepage-card-list-item slaask-widget-homepage-card-list-item-with-image" style="border-top:0!important;padding-top:0;">
              <div class="slaask-widget-homepage-card-list-item-part slaask-widget-homepage-card-list-item-image">
                <img src="${this.app._ph_info.image}">
              </div>
              <div class="slaask-widget-homepage-card-list-item-part">
                <p class="slaask-widget-homepage-card-list-item-title">
                  ${this.app._ph_info.name}
                </p>
                <p class="slaask-widget-homepage-card-list-item-subtitle">
                  ${this.app._ph_info.desc}
                </p>
              </div>
            </div>
          </div>
          <a target="_blank" href="${this.app._ph_info.url}" class="slaask-widget-homepage-cta" style="background-color: ${this.app._window_color};color: ${this.app._title_color}">
            <svg width="12" height="10" viewBox="0 0 9 8" xmlns="http://www.w3.org/2000/svg"><path d="M9 8H0l4.5-8L9 8z" fill="#fff" fill-rule="evenodd"></path></svg>&nbsp;&nbsp;Upvote (${parseInt(this.app._ph_info.votes).toLocaleString()})
          </a>
        </div>`
    }

    for (var i = 0; i < this.app._old_custom_cards.length; i++) {
      let customCard = this.app._old_custom_cards[i]

      if (customCard) {
        if (customCard.blocks) {
          if (customCard.blocks[0].position == 'before') {
            attentionGrabberHtml += Homepage.createCustomBlocks(customCard.blocks, true)
          } else {
            customsCardHtml += Homepage.createCustomBlocks(customCard.blocks, true)
          }
        } else {
          customsCardHtml += `
            <a target="_blank" id="slaask-widget-homepage-status" class="slaask-widget-homepage-card slaask-widget-homepage-card-link slaask-widget-card" href="${customCard['link']}">
              <div class="slaask-widget-homepage-card-content">
                <span class="slaask-widget-homepage-card-title">
                  ${customCard['title']}
                </span>
                <p>
                  ${customCard['description']}
                </p>
              </div>
            </a>
          `
        }
      }
    }

    return attentionGrabberHtml + conversationsCardHtml + productHuntCardHtml + statusCardHtml + helpCenterCardHtml + meetingsCardHtml + newsletterCardHtml + phoneCardHtml + customsCardHtml;
  }

  _canDisplayCustomCard(custom_card) {
    return this.app._homepage_global_scope === true
        || custom_card.widgets_custom_card.scope === 'global'
        || custom_card.widgets_custom_card.scope === Homepage.getUserKind()
  }

  buildCards(previewCards = null) {
    const cards = previewCards ? previewCards : this.app._custom_cards
    let cardsBuilt = []

    cards.forEach((custom_card) => {
      if (this._canDisplayCustomCard(custom_card)) {
        let htmlFormat = custom_card.layout.format
        let cardElements = ""
        let cardBlocks = []

        custom_card.blocks.forEach(function(block) {
          let blockLabel = Object.keys(block)[0]
          let blockData = {
            types: {
              blockLabel: blockLabel,
              blockType: block[blockLabel].type
            },
            format: block[blockLabel].format,
            settings: block[blockLabel].settings,
            settings_format: block[blockLabel].settings_layout,
            domElement: []
          }

          blockData.settings.list = []

          blockData.format.layout.forEach(function(element) {
            blockData.domElement.push(HtmlBuilder.buildHtml(element, blockData.settings, blockData.settings_format, blockData.types))
          })

          cardBlocks.push(blockData)
        });

        HtmlBuilder.loadCardBlocks(cardBlocks)
        htmlFormat.layout.forEach(function(element) {
          const builtCard = HtmlBuilder.buildHtml(element)

          if (builtCard) {
            cardElements += builtCard.outerHTML
          }
        })

        cardsBuilt.push(cardElements)
      }
    })

    this.blocksPostLoadIds = HtmlBuilder.getPostBuildQueue()
    HtmlBuilder.reset()

    return (cardsBuilt)
  }

  _newHtmlBase() {
    let homepageHtml = "";
    const cards = this.buildCards()

    cards.forEach(function(card) {
      homepageHtml += card
    })

    return(homepageHtml)
  }

  _htmlBase() {
    if (this.app._custom_cards.length !== 0) {
      return (this._newHtmlBase())
    } else {
      return (this._oldHtmlBase())
    }
  }
});
